import request from "../../utils/request";




//  注册
export function register(data) {
    return request({
        url: '/api/auth/register',
        method: 'post',
        data
    })
}


//  获取验证码

export function code(data) {
    return request({
        url: '/api/auth/code',
        method: 'post',
        data
    })
}